import { render, staticRenderFns } from "./contracts_by_collaborator.vue?vue&type=template&id=bc0fff6c&"
import script from "./contracts_by_collaborator.vue?vue&type=script&lang=js&"
export * from "./contracts_by_collaborator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports